// extracted by mini-css-extract-plugin
export default {"wrapper":"Filter_wrapper__GTy1t"};